// extracted by mini-css-extract-plugin
module.exports = {"title":"ShortText_title__2SxUM"};